<template>
  <div
    class="flex felx-row items-center space-x-1 text-sm text-text align-middle"
  >
    <!-- Avatar group skeleton -->
    <span class="inline-flex items-center -space-x-2.5 relative">
      <Skeleton
        v-for="index in 3"
        :key="index"
        width="32px"
        height="32px"
        border-radius="50%"
        :style="{ 'z-index': 3 - index }"
      />
    </span>

    <!-- Online count skeleton -->
    <Skeleton width="40px" height="16px" border-radius="4px" />

    <!-- Status text skeleton -->
    <Skeleton width="60px" height="16px" border-radius="4px" />

    <!-- Online indicator -->
    <div class="block rounded-full size-2 bg-fill-success"></div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "@/components/ui/layout/skeleton.vue";
</script>
